"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_entertainment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "entertainment-mid"), /*#__PURE__*/React.createElement("g", {
    id: "6b36f2f0-2257-47c6-884a-fd16fc1bb750",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c2891040-046f-4b77-b4e6-4b9da39331df",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.89,111.06l11.73-53.9c.87-2.88,2.94-4.6,4.45-4.6a1.92,1.92,0,0,1,.72.14,300.77,300.77,0,0,0,86.44,20.4,2.38,2.38,0,0,1,1.72,1.1,7.22,7.22,0,0,1,.81,5.78L162.84,126.3c-4.32,15.55-20,31.11-45.3,45A21.89,21.89,0,0,1,89,164.58c-14.16-20.45-21.35-38.74-21.14-53.52",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.89,111a16.65,16.65,0,0,1-2.48-.94A119.26,119.26,0,0,1,47.34,99.73C37.28,92.58,30.86,84.85,28.47,76.88L18.18,42.62c-.52-2.24.19-4.17,1.19-4.74a1.46,1.46,0,0,1,.53-.18,229.83,229.83,0,0,0,65-19.55,1.82,1.82,0,0,1,1.56.07,5.51,5.51,0,0,1,2.74,3.51l11.41,36.45",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,134s2.66,8.65,16,12,20-4,20-4",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,73.5C62,78,60,88,60,88",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "4deee0f5-3993-4781-88e3-93a77d1d25ce",
    "data-name": "<Pfad>",
    x1: 106,
    y1: 94,
    x2: 94,
    y2: 94,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "79a8483c-a54c-4127-9483-231b12a7c2fc",
    "data-name": "<Pfad>",
    x1: 74,
    y1: 46,
    x2: 66,
    y2: 46,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "c0d4de5d-2bb3-4573-8645-d4378dd2c48e",
    "data-name": "<Pfad>",
    x1: 50,
    y1: 52,
    x2: 42,
    y2: 58,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "a1fe16c1-b8b1-41e9-aa0e-0a82288abcb6",
    "data-name": "<Pfad>",
    x1: 142,
    y1: 110,
    x2: 134,
    y2: 102,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))));
}

var _default = ic_entertainment;
exports.default = _default;